import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navbar", "hero", "features"]

  connect() {
    this.setupScrollEffects()
    this.setupAnimations()
    this.setupCounters()
  }

  setupScrollEffects() {
    // Navbar background on scroll
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        this.navbarTarget.classList.add('bg-white', 'shadow-lg')
        this.navbarTarget.classList.remove('bg-transparent')
      } else {
        this.navbarTarget.classList.remove('bg-white', 'shadow-lg')
        this.navbarTarget.classList.add('bg-transparent')
      }
    })
  }

  setupAnimations() {
    // Intersection Observer for fade-in animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in')
          entry.target.classList.remove('opacity-0', 'translate-y-8')
        }
      })
    }, observerOptions)

    // Observe all feature cards
    document.querySelectorAll('.feature-card').forEach(card => {
      card.classList.add('opacity-0', 'translate-y-8', 'transition-all', 'duration-700')
      observer.observe(card)
    })

    // Observe benefit items
    document.querySelectorAll('.benefit-item').forEach(item => {
      item.classList.add('opacity-0', 'translate-y-8', 'transition-all', 'duration-700')
      observer.observe(item)
    })
  }

  setupCounters() {
    // Animate counters when they come into view
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateCounter(entry.target)
          counterObserver.unobserve(entry.target)
        }
      })
    }, { threshold: 0.5 })

    document.querySelectorAll('.counter').forEach(counter => {
      counterObserver.observe(counter)
    })
  }

  animateCounter(element) {
    const target = parseInt(element.dataset.target)
    const duration = 2000
    const increment = target / (duration / 16)
    let current = 0

    const timer = setInterval(() => {
      current += increment
      if (current >= target) {
        current = target
        clearInterval(timer)
      }
      element.textContent = Math.floor(current) + (element.dataset.suffix || '')
    }, 16)

    // Animate progress bars
    const progressBars = document.querySelectorAll('[data-width]')
    progressBars.forEach(bar => {
      const width = bar.dataset.width
      setTimeout(() => {
        bar.style.width = width
      }, 500)
    })
  }

  // Smooth scroll to section
  scrollToSection(event) {
    event.preventDefault()
    const targetId = event.currentTarget.getAttribute('href')
    const targetElement = document.querySelector(targetId)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  // Mobile menu toggle
  toggleMobileMenu() {
    const mobileMenu = document.getElementById('mobile-menu')
    mobileMenu.classList.toggle('hidden')
  }

  // Feature card hover effects
  featureCardHover(event) {
    const card = event.currentTarget
    card.style.transform = 'translateY(-8px)'
    card.style.transition = 'transform 0.3s ease'
  }

  featureCardLeave(event) {
    const card = event.currentTarget
    card.style.transform = 'translateY(0)'
  }
}
